import { isDeviceControlTranasaction, isValidBusinessObject } from '@iotv/datamodel-core';
import { createContext } from 'react';
const debug = process.env.REACT_APP_DEBUG && false;
export const isValidDCT = (item) => isValidBusinessObject(item) && isDeviceControlTranasaction(item);
/** with one or and array of DCTs either update existing dct or insert dct before next most recent */
const addTtoFiFoArray = (fifoArray, dcts) => {
    if (dcts instanceof Array) {
        debug && console.log(`addTtoFiFoArray has ${dcts.length} dcts`);
        return dcts.reduce((a, dct) => {
            a = addTtoFiFoArray(a, dct);
            return a;
        }, fifoArray ?? []);
    }
    else {
        if (fifoArray === null) {
            fifoArray = [];
        }
        const existingIdx = fifoArray.findIndex((item) => item.sk === dcts.sk);
        if (existingIdx > -1) {
            fifoArray.splice(existingIdx, 1, dcts);
        }
        else {
            const insertIdx = fifoArray.findIndex((item) => item.timestamp < dcts.timestamp);
            fifoArray.splice(insertIdx, 0, dcts);
        }
    }
    debug && console.log(`addTtoFiFoArray returing dcts`, { fifoArray });
    return fifoArray;
};
const isLoadEntityAction = (x) => {
    const c = x;
    return !!c && c.type === 'LoadEntity' && !!c.value && isValidBusinessObject(c.value.Entity);
};
const isUpdateAction = (x) => {
    const c = x;
    return !!c && c.type === 'Update' && !!c.action;
};
const isAddTransactionsAction = (x) => {
    const c = x;
    return !!c && c.type === 'AddTransactions' && !!c.value && c.value.dcts instanceof Array && c.value.dcts.length > 0 && c.value.dcts.every(isValidDCT);
};
/** this reducer handles the combined state for one Entity, its not yet used for the display of transactions for one entity
 * When called in EntityGroupControlReducer, it is used to populate an EntityState object, where the FifoDCTs are remerged with the entity
 *
 */
export const EntityControlReducer = (prev, action) => {
    const update = { ...prev };
    if (isLoadEntityAction(action)) {
        debug && console.log(`EntityControlReducer got ${action.type}`);
        return loadEntityReducer(prev, action);
    }
    else if (isUpdateAction(action)) {
        debug && console.log(`EntityControlReducer got ${action.type}`);
        Object.assign(update, action);
        return update;
    }
    else if (isAddTransactionsAction(action)) {
        debug && console.log(`EntityControlReducer (AddTransactionsAction) got ${action.type}`, action.value);
        const { value: { dcts, entity }, } = action;
        const clone = [...(update.FifoDCTs ?? [])];
        update.FifoDCTs = dcts.reduce((a, dct) => {
            const exitingIdx = clone.findIndex((existing) => dctsMatch(existing, dct));
            if (exitingIdx !== -1) {
                // replace matched
                a.splice(exitingIdx, 1, dct);
            }
            else {
                a.unshift(dct);
            }
            return a;
        }, clone);
        debug && console.log(`EntityControlReducer (AddTransactionsAction) updated FifoDCTs`, update.FifoDCTs);
        return update;
    }
    else {
        console.log(`WARN: unknown action type`, action);
        return update;
    }
};
const dctsMatch = (dct1, dct2) => {
    const { AWS_MessageId: AWS_MessageId_1, broadcastScheduleSk: broadcastScheduleSk_1, sk: sk_1, timestamp: timestamp_1 } = dct1;
    const { AWS_MessageId: AWS_MessageId_2, broadcastScheduleSk: broadcastScheduleSk_2, sk: sk_2, timestamp: timestamp_2 } = dct2;
    const matchedOnAWS_MessageId = AWS_MessageId_1 === AWS_MessageId_2;
    const matchedOnBroadcastScheduleSk = broadcastScheduleSk_1 === broadcastScheduleSk_2;
    const matchedOnSk = sk_1 === sk_2;
    const matchedOnTimestamp = timestamp_1 === timestamp_2;
    if (AWS_MessageId_1 && AWS_MessageId_2 && matchedOnAWS_MessageId) {
        /* AWS LP_WAN DCT */
        debug && console.log(`EntityControlReducer (AddTransactionsAction) matched on AWS_MessageID`, AWS_MessageId_1);
        return true;
    }
    else if (matchedOnBroadcastScheduleSk) {
        if (matchedOnSk && matchedOnTimestamp) {
            /* NON AWS LP_WAN DCT */
            debug &&
                console.log(`EntityControlReducer (AddTransactionsAction) matched on broadcastSk, dct sk and timestamp but not on AWS_MessageID`, AWS_MessageId_1);
            return true;
        }
        else {
            return false;
        }
    }
    else if (matchedOnSk && matchedOnTimestamp) {
        /* NON BROADCAST DCT */
        return true;
    }
    else {
        return false;
    }
};
const loadEntityReducer = (prev, action) => {
    const update = { ...prev };
    const { Entity } = action.value;
    update.Entity = Entity;
    return update;
};
export const defaultState = {
    Entity: null,
    FifoDCTs: null,
};
export const SingleEntityControlContext = createContext({
    state: defaultState,
    dispatch: (a) => {
        throw new Error('Uninitalized EntityControlReducer usage');
    },
});
